import { configureStore } from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';
import { rootReducer, rootSaga } from './root';

// disable thunk and add redux-saga middleware
const sagaMiddleware = createSagaMiddleware();
const store = configureStore({
  reducer: rootReducer,
  middleware: getDefaultMiddleware => {
    return [...getDefaultMiddleware({ thunk: false }), sagaMiddleware];
  },
});

sagaMiddleware.run(rootSaga);

// RootState also lives in store/root/reducers (same shape) so selectors can
// use `import type` without touching this module's store-creation side effects
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
